import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Select, Card, Row, Col, DatePicker, InputNumber, TimePicker, Drawer, AutoComplete, Collapse, Descriptions, Switch, Radio, Space, Table, Typography, Modal, Divider } from 'antd';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Link, useHistory } from "react-router-dom";
import { LabellingDto, LotCodeDropDown, VarientIdRequest, LabelIdRequest } from '@gtpl/shared-models/production-management';
import { CountryDto, MasterBrandsDropDownDto, ProductDto } from '@gtpl/shared-models/masters';
import { ProductService, MasterBrandService, CountryService } from '@gtpl/shared-services/masters'
import { SaleOrderService, saleOrder, SaleOrderItemsRequest } from '@gtpl/shared-services/sale-management';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons'
import './code-list-main-form.css';
import { CodeListMainService, CodeListService } from '@gtpl/shared-services/planning';
import { ItemsDetails, SaleOrderDetailViewInfoDTO, SaleOrderIdsRequest, SoNumbersModel } from '@gtpl/shared-models/sale-management';
import { SoItemDetailsBySoIdDTO } from 'libs/shared-models/sale-management/src/lib/sale-order/dto/so-item-details-by-so-id.dto';
import { LotCodeOpsService } from '@gtpl/shared-services/production';
import moment from 'moment';
import { CodeListMainItemsDto } from 'libs/shared-models/planning/src/lib/code-list-main/code-list-main-items.dto';
import { CodeListMainDto, CodeListMainIdRequest, CodeListValidationReq } from '@gtpl/shared-models/planning';
import { ColumnProps } from 'antd/lib/table';
import { PlantIdRequest } from '@gtpl/shared-models/warehouse-management';
import { SaleOrderIdRequest } from '@gtpl/shared-models/procurement-management';

/* eslint-disable-next-line */
export interface CodeListMainFormProps {
  isUpdate: boolean;
  closeForm: () => void;
  selectedData: CodeListMainDto;
}

export function CodeListMainForm(
  props: CodeListMainFormProps
) {
  const { Panel } = Collapse;
  const [form] = Form.useForm();
  const { Option } = Select;
  const codeListMainService = new CodeListMainService()
  const [saleOrderData, setSaleOrderData] = useState<SoNumbersModel[]>([]);
  const [soItemDetails, setSoItemDetails] = useState<SaleOrderDetailViewInfoDTO>(undefined);
  const [packStyle, setPackStyle] = useState<any[]>([])
  let history = useHistory()
  const [codeListItems] = Form.useForm()
  const [soItemDropdown, setSoItemDropdown] = useState<any[]>([])
  const [tableData, setTableData] = useState<CodeListMainItemsDto[]>([])
  const soItemService = new SaleOrderService;
  const [dataSource, setDataSource] = useState<CodeListMainItemsDto[]>([]);
  const [codeListData, setCodeListData] = useState<any[]>([]);
  const soService = new SaleOrderService();
  const [tracebilityCode, setTracebilityCode] = useState<any>()
  const codeListService = new CodeListService();
  const { Text } = Typography;
  const [page, setPage] = React.useState(1);

  let totCartons = 0;


  useEffect(() => {
    getSaleOrdersDropdown();
    getTracebilityCodes();

  }, []);


  const getSaleOrdersDropdown = () => {
    soService.getSaleOrdersDropDownList().then((res) => {
      if (res.status) {
        setSaleOrderData(res.data);
      } else {
        setSaleOrderData([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setSaleOrderData([]);
    });
  }

  const getSoItemsDropdown = () => {
    const saleOrderId = form.getFieldValue('saleOrderId')
    const req = new saleOrder(saleOrderId)
    soService.getProductForSoId(req).then((res) => {
      if (res.status) {
        setSoItemDropdown(res.data)
      } else {
        setSoItemDropdown([])
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setSoItemDropdown([]);
    })
  }

  const getPackStyleForSoItem = () => {
    const req = new SaleOrderItemsRequest()
    req.saleOrderId = form.getFieldValue('saleOrderId');
    req.saleOrderItemId = form.getFieldValue('saleOrderItemId')
    soService.getPackStyleForSoItem(req).then((res) => {
      if (res.status) {
        console.log(res.data,'pack style')
        setPackStyle(res.data)
        form.setFieldsValue({
          packStyleId : res.data[0].packStyle
        })

      } else {
        setPackStyle([])
        AlertMessages.getErrorMessage(res.internalMessage)
      }
    })
  }

  const getTracebilityCodes = () => {
    codeListService.getAllActiveCodeList().then((res) => {
      if (res.status) {
        setTracebilityCode(res.data);
      } else {
        setTracebilityCode([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setTracebilityCode([]);
    });
  }

  const getAllSoItemsDetails = () => {
    getSoItemsDropdown();
    const saleOrderId = form.getFieldValue('saleOrderId');
    const soREq: saleOrder = {
      saleOrderId: saleOrderId
    }
    soService.getSaleOrderDetailsById(soREq).then((res) => {
      if (res.status) {
        setSoItemDetails(res.data);
      } else {
        AlertMessages.getErrorMessage("Something went wrong");
        setSoItemDetails(res.data);
      }
    })
      .catch((err) => {
        AlertMessages.getErrorMessage(err.message);
      });
  };



  const saveData = (mainForm: CodeListMainDto) => {
    mainForm.codeListItems.forEach(item => {
      totCartons = Number(item.cartons) + Number(totCartons)
    })
    mainForm.totalCartons = totCartons
    if (totCartons == soItemDetails.totCases) {
      codeListMainService.createCodeListInfo(mainForm).then(res => {
        if (res.status) {
          AlertMessages.getSuccessMessage('Code List along with samples');
          history.push('/code-list-main-grid')
        } else {
          AlertMessages.getErrorMessage("Error while creating Code List");
          if (res.intlCode) {
            AlertMessages.getErrorMessage("Error while creating Code List");
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
          }
        }
      }).catch(err => {
        AlertMessages.getErrorMessage(err.message);
      })
    } else {
      AlertMessages.getErrorMessage('Add more cartons to fulfill the saleorder ')
      totCartons = 0;
    }
  }

  const onChange = (pagination, filters, sorter, extra) => {
    console.log('params', pagination, filters, sorter, extra);
  }


  const addFormItemToTable = async () => {
    await form.validateFields().then((res) => {
      console.log(res,'res')
      const data = new  CodeListMainItemsDto(res.saleOrderItemId,((res.code)),((res.tracebilityCodeId)),res.cartons,res.productionDate,res.bestBeforeDate,res.createdAt,res.createdUser,res.updatedAt,res.updatedUser,1)
      console.log(data,'data')
      console.log(tracebilityCode.find(i => i.codeListId == res.tracebilityCodeId).traceabilityCode,'trace')
      setTableData([...tableData,data])

    })

  }


  let createdUser = "";
  if (!props.isUpdate) {
    createdUser = localStorage.getItem("createdUser");
  }

  const onReset = () => {
    form.resetFields();
  };

  const onFocus = () => {
    console.log('focus');
  }

  const onSearch = (val) => {
    console.log('search:', val);
  }
  const onBlur = () => {
    console.log('blur');
  }

  

  const columnsSkelton: ColumnProps<any>[] = [
    {
      title: 'Sno',
      key: 'sno',
      width: '70px',
      responsive: ['sm'],
      render: (text, object, index) => (page - 1) * 10 + (index + 1)
    },
    {
      title: 'saleOrderItem',
      dataIndex: 'soItemId',
      render:(value) => {
        return soItemDropdown.find(i => i.saleOrderItemId == value).soItemName
      }
    },


    {
      title: 'Tracebility Code',
      dataIndex: 'tracebilityCodeId',
      render:(value) => {
        return tracebilityCode.find(i => i.codeListId ==value).traceabilityCode
      }

    },
    {
      title: 'Code',
      dataIndex: 'code',
      key:'code'

    },
    {
      title: 'Prod Date',
      dataIndex: 'productionDate',
      render:(value) => {
        return moment(value).format('DD-MM-YYYY')
      }

    },
    {
      title: 'Mfg Date',
      dataIndex: 'bestBeforeDate',
      render:(value) => {
        return moment(value).format('DD-MM-YYYY')
      }

    },
    {
      title:'Cartons',
      dataIndex:'cartons'
    }
  ]


  return (
    <Card title={<span style={{ color: 'white' }}>CodeList Form</span>}
      style={{ textAlign: 'center' }}
      headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
      extra={<Link to='/code-list-main-grid'>{<span style={{ color: 'white' }} ><Button className='panel_button' > View </Button> </span>}</Link>}
    >

      <Form form={form} name="control-hooks"
        layout="vertical"
        onFinish={saveData}
        initialValues={props.selectedData}
      >

        <Row gutter={24} >
          <Form.Item name="codeListMainId" >
            <Input hidden />
          </Form.Item>
          <Form.Item name="createdUser" initialValue={createdUser}>
            <Input hidden />
          </Form.Item>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
            <Form.Item name="saleOrderId" label="PO number" rules={[
              {
                required: true,
                message: 'Sale Order is Required'
              },
            ]}>
              <Select
                showSearch
                placeholder="Select Sale Order"
                optionFilterProp="children"
                onClick={getSoItemsDropdown}
                onFocus={onFocus}
                onBlur={onBlur}
                onSearch={onSearch}
                onClear={onReset}
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}

              >
                <Option key={0} value={null}>Select Sale Order</Option>
                {saleOrderData.map((saleOrder) => {
                  return <Option key={saleOrder.saleOrderId} value={saleOrder.saleOrderId}>{saleOrder.poNumber}</Option>
                })}
              </Select>
            </Form.Item>

          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item name="saleOrderItemId" label="Product SKU" rules={[
              {
                required: true,
                message: 'Product SKU  is Required'
              },
            ]}>
              <Select
                showSearch
                placeholder="Select Product SKU"
                optionFilterProp="children"
                onSelect={getPackStyleForSoItem}
                onFocus={onFocus}
                onBlur={onBlur}
                onSearch={onSearch}
                onClear={onReset}
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}

              >
                <Option key={0} value={null}>Select Product SKU</Option>
                {soItemDropdown.map((saleOrder) => {
                  return <Option key={saleOrder.saleOrderItemId} value={saleOrder.saleOrderItemId}>{saleOrder.soItemName}</Option>
                })}
              </Select>
            </Form.Item>

          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
            <Form.Item name="packStyleId"  label="Pack Style" rules={[
              {
                required: true,
                message: 'Pack Style  is Required'
              },
            ]}>
              <Input disabled />
            </Form.Item>

          </Col>


          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }} style={{ paddingTop: '28px' }}>
            <Button type="primary" onClick={getAllSoItemsDetails}>
              Submit
            </Button>
          </Col>
        </Row>
        <Row gutter={24} >

          <Descriptions style={{ display: (soItemDetails) ? 'unset' : 'none' }} column={{ xxl: 5, xl: 5, lg: 5, md: 1, sm: 1, xs: 1 }}>
            <Descriptions.Item label="Country" >
              {soItemDetails?.country}
            </Descriptions.Item>
            <Descriptions.Item label="Buyer" >
              {soItemDetails?.endCustomer}
            </Descriptions.Item>
            {/* <Descriptions.Item label="PO Number" >
              {soItemDetails?.poNo}
            </Descriptions.Item> */}
            <Descriptions.Item label="Total Cartons" >
              {soItemDetails?.totCases}
            </Descriptions.Item>
            <Descriptions.Item label=" Cartons" >
              {soItemDetails?.itemData?.find( i => i.saleOrderItemId == form.getFieldValue('saleOrderItemId')).jobCases}
            </Descriptions.Item>
           

          </Descriptions>
        </Row>
        <Divider type='horizontal' />
        <div style={{ display: (soItemDetails) ? 'unset' : 'none' }}>

        <Row gutter={24} >
         
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
            <Form.Item name="code" label="Code" rules={[
              {
                required: true,
                message: 'Code  is Required'
              },
            ]}>
              <Input />
            </Form.Item>

          </Col>


          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>

            <Form.Item
              label="Tracebility Code"
              name='tracebilityCodeId'
              rules={[{ required: true, message: 'Missing Tracebility code' }]}
            >
              <Select
                showSearch
                placeholder="Select Tracebility Code"
                optionFilterProp="children"
                onFocus={onFocus}
                onBlur={onBlur}
                onSearch={onSearch}
                onClear={onReset}
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                <Option key={0} value={null}>Select Tracebility Code</Option>
                {tracebilityCode?.map((item) => {
                  return <Option key={item.codeListId} value={item.codeListId}>{item.traceabilityCode}</Option>
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
            <Form.Item
              label="Production Date"
              name='productionDate'
              rules={[{ required: true, message: 'Missing Production Date' }]}
            >
              <DatePicker style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
            <Form.Item
              label="Best before Date"
              name='bestBeforeDate'
              rules={[{ required: true, message: 'Missing Best before Date' }]}
            >
              <DatePicker style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
            <Form.Item
              label="Cartons"
              name='cartons'
              rules={[{ required: true, message: 'Missing Cartons' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }} style={{ paddingTop: '28px' }}>
            <Button type="primary" onClick={addFormItemToTable}>
              Add
            </Button>
            {(props.isUpdate != true) ?
              <Button htmlType="button" style={{ margin: '0 14px' }} onClick={onReset}>
                Reset
              </Button> : ''
            }
          </Col>
        </Row>
      
        </div>
      { tableData.length > 0 ?
     
       <Table
        dataSource={tableData}
          columns={columnsSkelton}
          scroll={{ x: true }}
          pagination={{
            onChange(current) {
              setPage(current);
            }
          }}
          onChange={onChange}
          bordered /> : <></>
          }


      </Form>
    </Card >
  );
}

export default CodeListMainForm;
